module.exports = __webpack_public_path__ + "img/my lectures.c7911c58.png";